import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app'
import './index.css';
import { createStore } from 'redux';
import { Provider } from 'react-redux'
import reducers from './reducers/index'

const store = createStore(reducers)

ReactDOM.render(<Provider store={store}>
                 <App/>
                </Provider>, document.getElementById('root'))
